import { Component, OnInit, OnDestroy } from '@angular/core';
import { IoService } from '../../../services/io.service';
import { Subscription } from 'rxjs';
import { GaugeLevels } from '../../../widgets/gaugeLevels';

@Component({
  selector: 'app-dashboard-warehouse-becher',
  templateUrl: './dashboard-warehouse-becher.component.html',
  styleUrls: ['./dashboard-warehouse-becher.component.css']
})
export class DashboardWarehouseBecherComponent implements OnInit, OnDestroy {
  private subDeviceSmartbinLevels: Subscription;

  private triggerAlive: object;
  private lastContact = 99999;
  private lastContactTimeout;
  private levels: any = {Stab: 0, Becher: 0};
  gaugeLevelState = GaugeLevels.state;
  constructor(private ioService: IoService) { }

  ngOnInit() {
    this.subDeviceSmartbinLevels = this.ioService.getDeviceEvents('smartbin.levels').subscribe(ev => {
      console.log(ev);
      this.triggerAlive = {};
      this.levels.Becher = (ev.Becher && Math.round(ev.Becher))   || 0;
      this.levels.Stab   = (ev.Stab && Math.round(ev.Stab))   || 0;
      // this.size = Math.round(Math.random() * 200 + 100);
      // this.thick = Math.round(Math.random() * 20 + 2);
    });

    // grauslicher HACK SVG kann nicht mit overflow hidden (oder negativer margin) kontrolliert werden. Nur viewBox direkt verkleinern hilft
    setTimeout(() => {
      const mySVG = document.querySelectorAll('svg.gauge');
      mySVG.forEach(s => {
        s.setAttribute('viewBox', '0 0 100 50');
      });
    }, 1000);
  }

  ngOnDestroy() {
    if (this.subDeviceSmartbinLevels) { this.subDeviceSmartbinLevels.unsubscribe(); }
  }
}
